import { FunctionComponent } from "react";

import { InputField } from "@/components/InputField/InputField";

import { GmapsConfig } from "../onboardingListTypes";
import { ConfigField, ConfigGrid, useConfigTranslation, useFieldError } from "./ConfigField";
import { ConfigFormProps } from "./configFormProps";
import { SuggestingTextField } from "./SuggestingTextField";

/** MAPS — the Google Maps scraper takes a business type plus a plain country / city name. */
export const GmapsForm: FunctionComponent<ConfigFormProps<GmapsConfig>> = ({
	value,
	errors,
	options,
	onChange,
}) => {
	const ts = useConfigTranslation();
	const errorFor = useFieldError(errors);

	return (
		<ConfigGrid>
			<ConfigField full required error={errorFor("businessType")} label={ts("businessType")}>
				<InputField
					error={Boolean(errors.businessType)}
					handleChange={(event) => onChange({ ...value, query: event.target.value })}
					name="businessType"
					placeholder={ts("businessTypePlaceholder")}
					showError={Boolean(errors.businessType)}
					value={value.query}
				/>
			</ConfigField>

			<ConfigField required error={errorFor("country")} label={ts("country")}>
				<SuggestingTextField
					error={Boolean(errors.country)}
					fetchFn={options.fetchMapCountries}
					placeholder={ts("countryPlaceholder")}
					value={value.country}
					onChange={(country) => onChange({ ...value, country })}
				/>
			</ConfigField>

			<ConfigField label={ts("city")}>
				<SuggestingTextField
					fetchFn={options.fetchMapCities}
					placeholder={ts("cityPlaceholder")}
					value={value.city}
					onChange={(city) => onChange({ ...value, city })}
				/>
			</ConfigField>
		</ConfigGrid>
	);
};
